import { useEffect, useState } from 'react';
import cls from './RandomSpeech.module.scss';

const RandomSpeech = () => {
  const [count, setCount] = useState(0);
  const speechArr = [
    'Наставник настаивает',
    'Как дать волшебный пендель',
    'Где альпинистский крюк',
    'Как мотивировать людей',
    'Что пишут пацанские паблики',
  ];
  useEffect(() => {
    setTimeout(() => {
      if (count < 4) {
        setCount((act) => act + 1);
      } else {
        setCount(0);
      }
    }, 2000);
  }, [count]);
  return (
    <div className={cls.text}>
      <p className={cls.second_pp}>{speechArr[count]}</p>
      <p className={cls.first_pp}>{speechArr[count]}</p>
    </div>
  );
};

export default RandomSpeech;
